import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AbReport } from './commons/report.abstract';
import { AbTenant } from './full-pages/admin/tenant.abstract';
import { AbUsuario } from './full-pages/admin/usuario.abstract';
import { AbAgendaAreaComum } from './full-pages/agendamento/agenda-area-comum.abstract';
import { AbAreaComum } from './full-pages/area-comum/area-comum.abstract';
import { AbImpedimento } from './full-pages/area-comum/impedimento.abstract';
import { AbStepArea } from './full-pages/area-comum/step-area.abstract';
import { AbAssembleiaItemDiscuta } from './full-pages/assembleia/assembleia-item-discuta.abstract';
import { AbAssembleiaItemOpcaoVoto } from './full-pages/assembleia/assembleia-item-opcao-voto.abstract';
import { AbAssembleia } from './full-pages/assembleia/assembleia.abstract';
import { AbAssembleiaValidation } from './full-pages/assembleia/assembleia-validation.abstract';
import { AbItemAssembleia } from './full-pages/assembleia/item-assembleia.abstract';
import { AbOpcaoVoto } from './full-pages/assembleia/opcao-voto.abstract';
import { AbVoto } from './full-pages/assembleia/voto.abstract';
import { AbCftv } from './full-pages/cftv/cftv.abstract';
import { AbChamado } from './full-pages/chamado/chamado.abstract';
import { ChamadoService } from '../pages/full-pages/chamado/chamado.service';
import { AbConfigBiMulticonta } from './full-pages/config-bi-multiconta/config-bi-multiconta.abstract';
import { AbConfigCameras } from './full-pages/config-cameras/config-cameras.abstract';
import { AbConfigModulos } from './full-pages/config-modulos/config-modulos.abstract';
import { AbConviteVirtual } from './full-pages/convite-virtual/convite-virtual.abstract';
import { ConviteVirtualService } from 'app/pages/full-pages/convite-virtual/convite-virtual.service';
import { AbChaveVirtualAcesso } from './full-pages/chave-virtual-acesso/chave-virtual-acesso.abstract';
import { ChaveVirtualAcessoService } from 'app/pages/full-pages/chave-virtual-acesso/chave-virtual-acesso.service';
import { AbDispositivoZeladoria } from './full-pages/zelador-ia/dispositivo-zeladoria.abstract';
import { AbConfigPortas } from './full-pages/config-portas/config-portas.abstract';
import { AbPorta } from './full-pages/config-portas/porta.abstract';
import { PortaService } from '../pages/full-pages/configportas/porta.service';
import { AbStepConfigPSim } from './full-pages/config-psim/step-config-psim.abstract';
import { StepConfigpsimService } from '../pages/full-pages/configpsim/step-configpsim/step-configpsim.service';
import { AbBlocoPsim } from './full-pages/config-psim/bloco-psim.abstract';
import { AbConfigPsim } from './full-pages/config-psim/config-psim.abstract';
import { AbConfigScondKey } from './full-pages/config-scond-key/config-scond-key.abstract';
import { ConfigScondKeyService } from '../pages/full-pages/configscondkey/configscondkey.service';
import { AbConfigSeguranca } from './full-pages/config-scond-key/config-seguranca.abstract';
import { AbControlePrevisaoVisita } from './full-pages/config-scond-key/controle-previsao-visita.abstract';
import { ControlePrevisaoVisitaService } from '../pages/full-pages/configscondkey/configzonas/controle-previsao-visita.service';
import { AbConfigZonas } from './full-pages/config-scond-key/config-zonas.abstract';
import { ConfigZonasService } from '../pages/full-pages/configscondkey/configzonas/configzonas.service';
import { AbConfigSituator } from './full-pages/config-situator/config-situator.abstract';
import { ConfigSituatorService } from '../pages/full-pages/configsituator/configsituator.service';
import { AbConfigSkin } from './full-pages/config-skin/config-skin.abstract';
import { AbConfiguracaoAgendRelAmb } from './full-pages/configuracoes/configuracao-agend-rel-amb.abstract';
import { AbConfiguracoes } from './full-pages/configuracoes/configuracoes.abstract';
import { AbContaPublica } from './full-pages/conta/conta-publica.abstract';
import { AbConta } from './full-pages/conta/conta.abstract';
import { AbContrato } from './full-pages/contrato/contrato.abstract';
import { ContratoService } from '../pages/full-pages/contrato/contrato.service';
import { AbCorrespondencia } from './full-pages/correspondencia/correspondencia.abstract';
import { AbCredencial } from './full-pages/credencial/credencial.abstract';
import { AbSincronizar } from './full-pages/credencial/sincronizar.abstract';
import { SincronizarService } from '../pages/full-pages/credencial/sincronizar.service';
import { AbTipoCredencial } from './full-pages/credencial/tipo-credencial.abstract';
import { AbUsuarioCredencial } from './full-pages/credencial/usuario-credencial.abstract';
import { UsuarioCredencialService } from '../pages/full-pages/credencial/usuario-credencial.service';
import { AbAlert } from './full-pages/customs/alert/alert.abstract';
import { AbAmbiente } from './full-pages/customs/ambiente/ambiente.abstract';
import { AmbienteService } from '../pages/full-pages/customs/ambiente/ambiente.service';
import { AbEscolaridade } from './full-pages/customs/escolaridade/escolaridade.abstract';
import { EscolaridadeService } from '../pages/full-pages/customs/escolaridade/escolaridade.service';
import { AbEstadoCivil } from './full-pages/customs/estado-civil/estado-civil.abstract';
import { EstadoCivilService } from '../pages/full-pages/customs/estado-civil/estado-civil.service';
import { AbTipoDocumentoAdmin } from './full-pages/customs/tipo-documento-admin/tipo-documento-admin.abstract';
import { AbDistribuidor } from './full-pages/distribuidor/distribuidor.abstract';
import { DistribuidorService } from '../pages/full-pages/distribuidor/distribuidor.service';
import { AbDocumentos } from './full-pages/documentos/documentos.abstract';
import { AbDownload } from './full-pages/download/download.abstract';
import { AbEnquete } from './full-pages/enquete/enquete.abstract';
import { AbPortaDivisaArea } from './full-pages/equipamento/porta-divisa-area.abstract';
import { PortaDivisaoAreaService } from '../pages/full-pages/equipamento/porta/services/porta-divisa-area.service';
import { AbRecurso } from './full-pages/equipamento/recurso.abstract';
import { RecursoService } from '../pages/full-pages/equipamento/recurso/services/recurso.service';
import { AbTipoRecurso } from './full-pages/equipamento/tipo-recurso.abstract';
import { TipoRecursoService } from '../pages/full-pages/equipamento/tipo-recurso.service';
import { AbEstacionamento } from './full-pages/estacionamento/estacionamento.abstract';
import { EstacionamentoService } from '../pages/full-pages/estacionamento/estacionamento.service';
import { AbParking } from './full-pages/estacionamento/parking.abstract';
import { ParkingService } from '../pages/full-pages/estacionamento/add-parking-integration/parking.service';
import { AbEvento } from './full-pages/evento/evento.abstract';
import { AbGrupoPessoa } from './full-pages/grupo-pessoa/grupo-pessoa.abstract';
import { GrupoPessoaService } from '../pages/full-pages/grupo-pessoa/grupo-pessoa.service';
import { AbNotificacaoFuncionalidade } from './full-pages/grupo-pessoa/notificacao-funcionalidade.abstract';
import { NotificacaoFuncionalidadeService } from '../pages/full-pages/grupo-pessoa/notificacao-funcionalidade.service';
import { AbHorarios } from './full-pages/horarios/horarios.abstract';
import { AbPortaHub } from './full-pages/hub/porta-hub.abstract';
import { PortaHubService } from '../pages/full-pages/hub/porta-hub.service';
import { AbRecursoHub } from './full-pages/hub/recurso-hub.abstract';
import { RecursoHubService } from '../pages/full-pages/hub/recurso.service';
import { AbDispositivoHub } from './full-pages/hub/dispositivo-hub.abstract';
import { DispositivoHubService } from '../pages/full-pages/hub/dispositivo-hub.service';
import { AbInadimplente } from './full-pages/inadimplente/inadimplente.abstract';
import { AbConfigIntegrador } from './full-pages/integrador/config-integrador.abstract';
import { ConfigIntegradorService } from '../pages/full-pages/integrador/config-integrador/config-integrador.service';
import { AbIntegrador } from './full-pages/integrador/integrador.abstract';
import { IntegradorService } from '../pages/full-pages/integrador/integrador.service';
import { AbEnderecoIntegrador } from './full-pages/integrador/endereco-integrador.abstract';
import { EnderecoIntegradorService } from '../pages/full-pages/integrador/endereco-integrador/endereco-integrador.service';
import { AbSms } from './full-pages/integrador/sms.abstract';
import { SmsService } from '../pages/full-pages/integrador/sms/sms.service';
import { AbLgpd } from './full-pages/lgpd/lgpd.abstract';
import { AbListaConvidados } from './full-pages/lista-convidados/lista-convidados.abstract';
import { ListaConvidadosService } from '../pages/full-pages/lista-convidados/service/lista-convidados.service';
import { AbLoad } from './full-pages/load/load.abstract';
import { AbLocale } from './full-pages/locale/locale.abstract';
import { AbModelo } from './full-pages/locker/modelo.abstract';
import { ModeloService } from '../pages/full-pages/locker/modelo.service';
import { AbDispositivo } from './full-pages/locker/dispositivo.abstract';
import { DispositivoService } from '../pages/full-pages/locker/dispositivo.service';
import { AbConfigBiccateca } from './full-pages/locker/config-biccateca.abstract';
import { ConfigBiccatecaService } from '../pages/full-pages/locker/config-biccateca.service';
import { AbConfigDispositivo } from './full-pages/locker/config-dispositivo.abstract';
import { ConfigDispositivoService } from '../pages/full-pages/locker/config-dispositivo.service';
import { AbLogIntegracao } from './full-pages/log-integracao/log-integracao.abstract';
import { AbLogNotificacao } from './full-pages/log-notificacao/log-notificacao.abstract';
import { AbLogWebHook } from './full-pages/log-webhook/log-webhook.abstract';
import { AbUsuarioConta } from './full-pages/meus-dados/usuario-conta.abstract';
import { AbMorador } from './full-pages/meus-dados/morador.abstract';
import { AbPet } from './full-pages/meus-dados/pet.abstract';
import { AbEnderecoContato } from './full-pages/meus-dados/endereco-contato.abstract';
import { AbMigracao } from './full-pages/migracao/migracao.abstract';
import { MigracaoService } from '../pages/full-pages/migracao/migracao.service';
import { AbPerfilAcesso } from './full-pages/perfil-acesso/perfil-acesso.abstract';
import { AbPessoa } from './full-pages/pessoa/pessoa.abstract';
import { AbPlanilha } from './full-pages/planilha/planilha.absact';
import { AbPortaria } from './full-pages/portaria/portaria.abstract';
import { AbPortariaFuncionario } from './full-pages/portaria-funcionario/portaria-funcionario.abstract';
import { AbPreCadastro } from './full-pages/pre-cadastro/pre-cadastro.abstract';
import { PreCadastroService } from '../pages/full-pages/pre-cadastro/precadastro.service';
import { AbRecado } from './full-pages/recado/recado.abstract';
import { AbRelatorioAcionamentos } from './full-pages/relatorios/relatorio-acionamento.abstract';
import { RelatorioAcionamentosServices } from '../pages/full-pages/relatorios/relatorio-acionamentos/relatorio-acionamentos.service';
import { AbRelatorioChamadas } from './full-pages/relatorios/relatorio-chamadas.abstract';
import { RelatorioChamadasService } from '../pages/full-pages/relatorios/relatorio-chamadas/relatorio-chamadas.service';
import { AbRelatorioLgpd } from './full-pages/relatorios/relatorio-lgpd.abstract';
import { RelatorioLgpdService } from '../pages/full-pages/relatorios/relatorio-lgpd/service/relatorio-lgpd.service';
import { AbRelatorioPortaria } from './full-pages/relatorios/relatorio-portaria.abstract';
import { RelatorioPortariaService } from '../pages/full-pages/relatorios/relatorio-portaria/relatorio-portaria.service';
import { AbRelatorioPrimeiroAcesso } from './full-pages/relatorios/relatorio-primeiro-acesso.abstract';
import { RelatorioPrimeiroAcessoServices } from '../pages/full-pages/relatorios/relatorio-primeiro-acesso/relatorio-primeiro-acesso.services';
import { AbRelatorioPrimeiroAcessoConta } from './full-pages/relatorios/relatorio-primeiro-acesso-conta.abstract';
import { RelatorioPrimeiroAcessoContaServices } from '../pages/full-pages/relatorios/relatorio-primeiro-acesso-conta/relatorio-primeiro-acesso-conta.services';
import { AbRelatorioUnidades } from './full-pages/relatorios/relatorio-unidades.abstract';
import { RelatorioUnidadesServices } from '../pages/full-pages/relatorios/relatorio-unidades/relatorio-unidades.service';
import { AbSubIntegrador } from './full-pages/sub-integrador/sub-integrador.abstract';
import { SubIntegradorService } from '../pages/full-pages/sub-integrador/sub-integrador.service';
import { AbEventoPsim } from './full-pages/timeline-eventos/evento-psim.abstract';
import { AbTipoEventoPsim } from './full-pages/tipo-evento-psim/tipo-evento-psim.abstract';
import { AbUnidade } from './full-pages/unidade/unidade.abstract';
import { AbStep } from './full-pages/unidade/step.abstract';
import { StepService } from '../pages/full-pages/unidade/step/step.service';
import { AbStepVagas } from './full-pages/vaga/step-vaga.abstract';
import { StepVagasService } from '../pages/full-pages/vaga/vaga-cadastro-automatico/step-vagas/step-vagas.service';
import { AbVagaUnidade } from './full-pages/vaga/vaga-unidade.abstract';
import { AbTipoVaga } from './full-pages/vaga/tipo-vaga.abstract';
import { AbVaga } from './full-pages/vaga/vaga.abstract';
import { AbVeiculo } from './full-pages/veiculo/veiculo.abstract';
import { AbVersaoAppLoja } from './full-pages/versao-app-loja/versao-app-loja.abstract';
import { VersaoAppLojaService } from '../pages/full-pages/versao-app-loja/versao-app-loja.service';
import { AbConfigVoip } from './full-pages/voip/config-voip.abstract';
import { AbDispositivoSip } from './full-pages/voip/dispositivo-sip.abstract';
import { AbTronco } from './full-pages/voip/tronco.abstract';
import { AbLogin } from './content-pages/login/login.abstract';
import { AbApp } from './services/app.abstract';
import { AbToastr } from './services/toastr.abstract';
import { ReportService } from "app/commons/report.service";
import { AbStepAssembleia } from "./full-pages/assembleia/step-assembleia.abstract";
import { TenantService } from "app/pages/full-pages/admin/tenant/tenant.service";
import { UsuarioService } from "app/pages/full-pages/admin/usuario.service";
import { AgendaAreaComumService } from "app/pages/full-pages/agendamento/agenda-area-comum.service";
import { AreaComumService } from "app/pages/full-pages/area-comum/area-comum.service";
import { ImpedimentoService } from "app/pages/full-pages/area-comum/impedimento.service";
import { StepAreaService } from "app/pages/full-pages/area-comum/step-area.service";
import { AssembleiaItemDiscutaService } from "app/pages/full-pages/assembleia/assembleia-service/assembleia-item-discuta.service";
import { AssembleiaItemOpcaoVotoService } from "app/pages/full-pages/assembleia/assembleia-service/assembleia-item-opcao-voto.service";
import { AssembleiaService } from "app/pages/full-pages/assembleia/assembleia-service/assembleia.service";
import { LoginService } from "app/pages/content-pages/login/login.service";
import { AssembleiaValidationsService } from "app/pages/full-pages/assembleia/assembleia-service/assembleiaValidations.service";
import { ItemAssembleiaService } from "app/pages/full-pages/assembleia/assembleia-service/item-assembleia.service";
import { OpcaoVotoService } from "app/pages/full-pages/assembleia/assembleia-service/opcao-votos.service";
import { VotoService } from "app/pages/full-pages/assembleia/assembleia-service/voto.service";
import { StepAssembleiaService } from "app/pages/full-pages/assembleia/step-assembleia/step-assembleia.service";
import { CamerasService } from "app/pages/full-pages/cameras/cameras.service";
import { CftvService } from "app/pages/full-pages/cftv/cftv.service";
import { ConfigBIMultiContaService } from "app/pages/full-pages/configbimulticonta/config-bi-multiconta.service";
import { ConfigCamerasService } from "app/pages/full-pages/configcameras/configcameas.service";
import { ConfigModulosService } from "app/pages/full-pages/configmodulos/configmodulos.service";
import { DispositivoZeladoriaService } from "app/pages/full-pages/zelador-ia/dispositivo/dispositivo-zeladoria.service";
import { ConfigPortasService } from "app/pages/full-pages/configportas/configportas.service";
import { BlocoPSIMService } from "app/pages/full-pages/configpsim/blocopsim.service";
import { ConfigPSIMService } from "app/pages/full-pages/configpsim/configpsim.service";
import { ConfigSegurancaService } from "app/pages/full-pages/configscondkey/configseguranca.service";
import { ConfigSkinService } from "app/pages/full-pages/configskin/configskin.service";
import { ConfigRelAgendAmbService } from "app/pages/full-pages/configuracoes/configuracao-agend-rel-amb.service";
import { ConfiguracoesService } from "app/pages/full-pages/configuracoes/configuracoes.service";
import { ContaPublicaService } from "app/pages/full-pages/conta/conta-publica.service";
import { ContaService } from "app/pages/full-pages/conta/conta.service";
import { CorrespondenciaService } from "app/pages/full-pages/correspondencia/correspondencia.service";
import { CredencialService } from "app/pages/full-pages/credencial/credencial.service";
import { TipoCredencialService } from "app/pages/full-pages/credencial/tipo-credencial.service";
import { AlertService } from "app/pages/full-pages/customs/alert/alert.service";
import { TipoDocumentoAdminService } from "app/pages/full-pages/customs/tipo-documento-admin/tipo-documento-admin.service";
import { DocumentosService } from "app/pages/full-pages/documentos/service/documentos.service";
import { DownloadService } from "app/pages/full-pages/download-service/download.service";
import { EnqueteService } from "app/pages/full-pages/enquete/enquete.service";
import { EventoService } from "app/pages/full-pages/evento/evento.service";
import { HorariosService } from "app/pages/full-pages/horarios/horarios.service";
import { InadimplentService } from "app/pages/full-pages/inadimplente/service/inadimplente.service";
import { LgpdService } from "app/pages/full-pages/lgpd/service/lgpd.service";
import { LoadService } from "app/pages/full-pages/load/load.service";
import { LocaleService } from "app/pages/full-pages/locale/locale.service";
import { LogIntegracaoService } from "app/pages/full-pages/log-integracao-component/log-integracao.service";
import { LogNotificacaoService } from "app/pages/full-pages/log-notificacao/service/log-notificacao.service";
import { LogWebhookService } from "app/pages/full-pages/log-webhook/service/log-webhook.service";
import { EnderecoContatoService } from "app/pages/full-pages/meus-dados/endereco-contato/endereco-contato.service";
import { MoradorService } from "app/pages/full-pages/meus-dados/morador/morador.service";
import { PetService } from "app/pages/full-pages/meus-dados/pet/pet.service";
import { UsuarioContaService } from "app/pages/full-pages/meus-dados/usuarioconta.service";
import { PerfilAcessoService } from "app/pages/full-pages/perfil-acesso/perfil-acesso.service";
import { PessoaService } from "app/pages/full-pages/pessoa/pessoa.service";
import { PlanilhaService } from "app/pages/full-pages/planilha/planilha.service";
import { PortariaFuncionarioService } from "app/pages/full-pages/portaria-funcionario/portaria-funcionario.service";
import { PortariaService } from "app/pages/full-pages/portaria/portaria.service";
import { RecadoService } from "app/pages/full-pages/recado/recado.service";
import { EventoPSIMService } from "app/pages/full-pages/timeline-eventos/evento-psim.service";
import { TipoEventoPsimService } from "app/pages/full-pages/tipoeventopsim/service/tipo-evento-psim.service";
import { UnidadeService } from "app/pages/full-pages/unidade/unidade.service";
import { TipoVagaService } from "app/pages/full-pages/vaga/tipovaga.service";
import { VagaUnidadeService } from "app/pages/full-pages/vaga/vaga-unidade/vaga-unidade.service";
import { VagaService } from "app/pages/full-pages/vaga/vaga.service";
import { VeiculoService } from "app/pages/full-pages/veiculo/veiculo.service";
import { ConfigVoipService } from "app/pages/full-pages/voip/services/config-voip.service";
import { DispositivoSipService } from "app/pages/full-pages/voip/services/dispositivo-sip.service";
import { TroncoService } from "app/pages/full-pages/voip/services/tronco.service";
import { AppService } from "app/services/app.service";
import { ToastrService } from "app/services/toastr.service";
import { AbCameras } from "./full-pages/cameras/cameras.abstract";
import { AbIcons } from "./icons/icons.abstract";
import { IconsService } from "app/lib/icons/icons.service";
import { AbGestaoPreCadastros } from "./full-pages/gestao-pre-cadastros/gestao-pre-cadastros.abstract";
import { GestaoPreCadastrosService } from "app/pages/full-pages/gestao-pre-cadastros/gestao-pre-cadastros.service";
import { AbAdminPreCadastro } from "./full-pages/admin-pre-cadastro/admin-pre-cadastro.abstract";
import { AdminPreCadastroService } from "app/pages/full-pages/integrador/inicio/components/pre-cadastro/admin-pre-cadastro.service";
import { AbAdminRecado } from "./full-pages/admin-recados/admin-recado.abstract";
import { AdminRecadoService } from "app/pages/full-pages/integrador/inicio/components/recado/admin-recado.service";
import { AbFeatureFlag } from "./services/feature-flag.abstract";
import { FeatureFlagService } from "app/services/feature-flag/feature-flag.service";
import { AbPostHog } from "./services/posthog.abstract";
import { PostHogService } from "app/services/posthog/posthog.service";
import { AbWhatsAppBusiness } from './full-pages/integrador/whatsapp-business.abstract';
import { WhatsAppBusinessService } from "app/pages/full-pages/integrador/whatsapp/whatsapp-business.service";
import { AbModoDebug } from './full-pages/integrador/modo-debug.abstract';
import { ModoDebugService } from "app/pages/full-pages/integrador/modo-debug/modo-debug.service";
import { AbEquipamentoPac } from './full-pages/equipamento-pac/equipamento-pac.abstract';
import { EquipamentoPacService } from "app/pages/full-pages/equipamento-pac/equipamento-pac.service";
import { AbPortaEquipamentoPac } from './full-pages/equipamento-pac/porta-equipamento-pac.abstract';
import { PortaEquipamentoPacService } from "app/pages/full-pages/equipamento-pac/porta-equipamento-pac.service";

@NgModule({
  imports: [CommonModule],
  providers: [

    {
      provide: AbReport,
      useClass: ReportService
    },
    {
      provide: AbTenant,
      useClass: TenantService
    },
    {
      provide: AbUsuario,
      useClass: UsuarioService
    },
    {
      provide: AbAgendaAreaComum,
      useClass: AgendaAreaComumService
    },
    {
      provide: AbAreaComum,
      useClass: AreaComumService
    },
    {
      provide: AbImpedimento,
      useClass: ImpedimentoService
    },
    {
      provide: AbStepArea,
      useClass: StepAreaService
    },
    {
      provide: AbAssembleiaItemDiscuta,
      useClass: AssembleiaItemDiscutaService
    },
    {
      provide: AbAssembleiaItemOpcaoVoto,
      useClass: AssembleiaItemOpcaoVotoService
    },
    {
      provide: AbAssembleia,
      useClass: AssembleiaService
    },
    {
      provide: AbAssembleiaValidation,
      useClass: AssembleiaValidationsService
    },
    {
      provide: AbItemAssembleia,
      useClass: ItemAssembleiaService
    },
    {
      provide: AbStepAssembleia,
      useClass: StepAssembleiaService
    },
    {
      provide: AbOpcaoVoto,
      useClass: OpcaoVotoService
    },
    {
      provide: AbVoto,
      useClass: VotoService
    },
    {
      provide: AbCameras,
      useClass: CamerasService
    },
    {
      provide: AbCftv,
      useClass: CftvService
    },
    {
      provide: AbChamado,
      useClass: ChamadoService
    },
    {
      provide: AbConfigBiMulticonta,
      useClass: ConfigBIMultiContaService
    },
    {
      provide: AbConfigCameras,
      useClass: ConfigCamerasService
    },
    {
      provide: AbConfigModulos,
      useClass: ConfigModulosService
    },
    {
      provide: AbConviteVirtual,
      useClass: ConviteVirtualService
    },
    {
      provide: AbChaveVirtualAcesso,
      useClass: ChaveVirtualAcessoService
    },
    {
      provide: AbDispositivoZeladoria,
      useClass: DispositivoZeladoriaService
    },
    {
      provide: AbConfigPortas,
      useClass: ConfigPortasService
    },
    {
      provide: AbPorta,
      useClass: PortaService
    },
    {
      provide: AbStepConfigPSim,
      useClass: StepConfigpsimService
    },
    {
      provide: AbBlocoPsim,
      useClass: BlocoPSIMService
    },
    {
      provide: AbConfigPsim,
      useClass: ConfigPSIMService
    },
    {
      provide: AbConfigScondKey,
      useClass: ConfigScondKeyService
    },
    {
      provide: AbConfigSeguranca,
      useClass: ConfigSegurancaService
    },
    {
      provide: AbControlePrevisaoVisita,
      useClass: ControlePrevisaoVisitaService
    },
    {
      provide: AbConfigZonas,
      useClass: ConfigZonasService
    },
    {
      provide: AbConfigSituator,
      useClass: ConfigSituatorService
    }
    ,
    {
      provide: AbConfigSkin,
      useClass: ConfigSkinService
    },
    {
      provide: AbConfiguracaoAgendRelAmb,
      useClass: ConfigRelAgendAmbService
    },
    {
      provide: AbConfiguracoes,
      useClass: ConfiguracoesService
    },
    {
      provide: AbContaPublica,
      useClass: ContaPublicaService
    },
    {
      provide: AbConta,
      useClass: ContaService
    },
    {
      provide: AbContrato,
      useClass: ContratoService
    },
    {
      provide: AbCorrespondencia,
      useClass: CorrespondenciaService
    },
    {
      provide: AbCredencial,
      useClass: CredencialService
    },
    {
      provide: AbSincronizar,
      useClass: SincronizarService
    },
    {
      provide: AbTipoCredencial,
      useClass: TipoCredencialService
    },
    {
      provide: AbUsuarioCredencial,
      useClass: UsuarioCredencialService
    },
    {
      provide: AbAlert,
      useClass: AlertService
    },
    {
      provide: AbAmbiente,
      useClass: AmbienteService
    },
    {
      provide: AbEscolaridade,
      useClass: EscolaridadeService
    },
    {
      provide: AbEstadoCivil,
      useClass: EstadoCivilService
    },
    {
      provide: AbTipoDocumentoAdmin,
      useClass: TipoDocumentoAdminService
    },
    {
      provide: AbDistribuidor,
      useClass: DistribuidorService
    },
    {
      provide: AbDocumentos,
      useClass: DocumentosService
    },
    {
      provide: AbDownload,
      useClass: DownloadService
    },
    {
      provide: AbEnquete,
      useClass: EnqueteService
    },
    {
      provide: AbPortaDivisaArea,
      useClass: PortaDivisaoAreaService
    },
    {
      provide: AbRecurso,
      useClass: RecursoService
    },
    {
      provide: AbTipoRecurso,
      useClass: TipoRecursoService
    },
    {
      provide: AbEstacionamento,
      useClass: EstacionamentoService
    },
    {
      provide: AbParking,
      useClass: ParkingService
    },
    {
      provide: AbEvento,
      useClass: EventoService
    },
    {
      provide: AbGrupoPessoa,
      useClass: GrupoPessoaService
    },
    {
      provide: AbNotificacaoFuncionalidade,
      useClass: NotificacaoFuncionalidadeService
    },
    {
      provide: AbHorarios,
      useClass: HorariosService
    },
    {
      provide: AbPortaHub,
      useClass: PortaHubService
    },
    {
      provide: AbRecursoHub,
      useClass: RecursoHubService
    },
    {
      provide: AbDispositivoHub,
      useClass: DispositivoHubService
    },
    {
      provide: AbInadimplente,
      useClass: InadimplentService
    },
    {
      provide: AbConfigIntegrador,
      useClass: ConfigIntegradorService
    },
    {
      provide: AbIntegrador,
      useClass: IntegradorService
    },
    {
      provide: AbEnderecoIntegrador,
      useClass: EnderecoIntegradorService
    },
    {
      provide: AbSms,
      useClass: SmsService
    },
    {
      provide: AbLgpd,
      useClass: LgpdService
    },
    {
      provide: AbListaConvidados,
      useClass: ListaConvidadosService
    },
    {
      provide: AbLoad,
      useClass: LoadService
    },
    {
      provide: AbLocale,
      useClass: LocaleService
    },
    {
      provide: AbModelo,
      useClass: ModeloService
    },
    {
      provide: AbDispositivo,
      useClass: DispositivoService
    },
    {
      provide: AbConfigBiccateca,
      useClass: ConfigBiccatecaService
    },
    {
      provide: AbConfigDispositivo,
      useClass: ConfigDispositivoService
    },
    {
      provide: AbLogIntegracao,
      useClass: LogIntegracaoService
    },
    {
      provide: AbLogNotificacao,
      useClass: LogNotificacaoService
    },
    {
      provide: AbLogWebHook,
      useClass: LogWebhookService
    },
    {
      provide: AbUsuarioConta,
      useClass: UsuarioContaService
    },
    {
      provide: AbMorador,
      useClass: MoradorService
    },
    {
      provide: AbPet,
      useClass: PetService
    },
    {
      provide: AbEnderecoContato,
      useClass: EnderecoContatoService
    },
    {
      provide: AbMigracao,
      useClass: MigracaoService
    },
    {
      provide: AbPerfilAcesso,
      useClass: PerfilAcessoService
    },
    {
      provide: AbPessoa,
      useClass: PessoaService
    },
    {
      provide: AbPlanilha,
      useClass: PlanilhaService
    },
    {
      provide: AbPortaria,
      useClass: PortariaService
    },
    {
      provide: AbPortariaFuncionario,
      useClass: PortariaFuncionarioService
    },
    {
      provide: AbPreCadastro,
      useClass: PreCadastroService
    },
    {
      provide: AbRecado,
      useClass: RecadoService
    },
    {
      provide: AbRelatorioAcionamentos,
      useClass: RelatorioAcionamentosServices
    },
    {
      provide: AbRelatorioChamadas,
      useClass: RelatorioChamadasService
    },
    {
      provide: AbRelatorioLgpd,
      useClass: RelatorioLgpdService
    },
    {
      provide: AbRelatorioPortaria,
      useClass: RelatorioPortariaService
    },
    {
      provide: AbRelatorioPrimeiroAcesso,
      useClass: RelatorioPrimeiroAcessoServices
    },
    {
      provide: AbRelatorioPrimeiroAcessoConta,
      useClass: RelatorioPrimeiroAcessoContaServices
    },
    {
      provide: AbRelatorioUnidades,
      useClass: RelatorioUnidadesServices
    },
    {
      provide: AbSubIntegrador,
      useClass: SubIntegradorService
    },
    {
      provide: AbEventoPsim,
      useClass: EventoPSIMService
    },
    {
      provide: AbTipoEventoPsim,
      useClass: TipoEventoPsimService
    },
    {
      provide: AbUnidade,
      useClass: UnidadeService
    },
    {
      provide: AbStep,
      useClass: StepService
    },
    {
      provide: AbStepVagas,
      useClass: StepVagasService
    },
    {
      provide: AbVagaUnidade,
      useClass: VagaUnidadeService
    },
    {
      provide: AbTipoVaga,
      useClass: TipoVagaService
    },
    {
      provide: AbVaga,
      useClass: VagaService
    },
    {
      provide: AbVeiculo,
      useClass: VeiculoService
    },
    {
      provide: AbVersaoAppLoja,
      useClass: VersaoAppLojaService
    },
    {
      provide: AbConfigVoip,
      useClass: ConfigVoipService
    },
    {
      provide: AbDispositivoSip,
      useClass: DispositivoSipService
    },
    {
      provide: AbTronco,
      useClass: TroncoService
    },
    {
      provide: AbLogin,
      useClass: LoginService
    },
    {
      provide: AbApp,
      useClass: AppService
    },
    {
      provide: AbToastr,
      useClass: ToastrService
    },
    {
      provide:AbIcons,
      useClass:IconsService
    },
    {
      provide: AbGestaoPreCadastros,
      useClass: GestaoPreCadastrosService
    },
    {
      provide: AbAdminPreCadastro,
      useClass: AdminPreCadastroService
    },
    {
      provide: AbAdminRecado,
      useClass: AdminRecadoService
    },
    {
      provide: AbFeatureFlag,
      useClass: FeatureFlagService
    },
    {
      provide: AbPostHog,
      useClass: PostHogService
    },
    {
      provide: AbWhatsAppBusiness,
      useClass: WhatsAppBusinessService
    },
    {
      provide: AbModoDebug,
      useClass: ModoDebugService
    },
    {
      provide: AbEquipamentoPac,
      useClass: EquipamentoPacService
    },
    {
      provide: AbPortaEquipamentoPac,
      useClass: PortaEquipamentoPacService
    }
  ]
})

export class AbstractModule {

}
